import { useEffect, useState } from 'react';
import { collection, Timestamp, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

// Define an interface for the order type
interface Order {
  id: string;
  name: string;
  status?: string; // Status might not be present on all orders
  toppings: string[];
  extra: string;
  createdAt: Timestamp;
}

export default function Status() {
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    return onSnapshot(collection(db, 'orders'), (querySnapshot) => {
      const ordersData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as Order[];
        setOrders(ordersData);
    })
  }, []);

  return (
    <main className="content">
      <section className="form-section">
        <h1 className="title">Bestellstatus</h1>
        <table className="status-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              {/* <th>Best{}ellt am</th> */}
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.id}>
                <td>{order.name}</td>
                <td>{order.status || 'Warteschlange'}</td>
                {/* <td>{order.createdAt ? new Date(order.createdAt.seconds * 1000).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '-'}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </main>
  );
}